export const dimensionHeaders = (
  names: (string | undefined)[] | undefined,
  count: number
): string[] =>
  Array.from({ length: count }, (_, i) => {
    // Header names are not included in the merge wire; fall back
    // to a default if the name is missing or blank.
    const name = names?.[i]?.trim();
    return name ? name : `Dimension ${i + 1}`;
  });
